import React from "react";
import { FaHome, FaBuilding  } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import CustomSwitch from "../../../component/elements/customSwitch";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";

export default function AddressCard({
  addressData,
  addressLabel,
  onEdit,
  onDelete,
  onSetDefault,
}) {
 const Icon = addressLabel.toLowerCase() === "home"
  ? FaHome
  : addressLabel.toLowerCase() === "office"
  ? FaBuilding
  : MdLocationOn; 

  return (
   <div className="bg-white rounded-2xl shadow-[0_0_10px_rgba(0,0,0,0.08)] px-6 py-5 w-full max-w-xl">
  {/* Top: Icon + Address */}
  <div className="flex items-start gap-4 w-full">
    <div className="p-3 bg-blue-50 rounded-lg text-[#3383B2] text-xl shrink-0">
      <Icon /> 
    </div>
    <div className="min-w-0">
      <div className="text-black font-bold">{addressLabel}</div>
      <p className="text-sm text-black font-medium break-words">
         {addressData.addressLine}
      </p>
    </div>
  </div>

  {/* Bottom: Toggle + Buttons */}
  <div className="flex justify-between gap-3 w-full mt-4">
    {/* Switch */}
    <div className="flex items-center gap-2">
      <CustomSwitch
  checked={!!addressData.is_primary}         
  onChange={(e) => {
      onSetDefault(e.target.checked); 
  }}
/>
      <span className="text-sm text-gray-700">Set as Primary</span>
    </div>

    {/* Buttons */}
<div className="flex gap-3">
      <button
  onClick={() => onEdit()}
  className="flex items-center gap-1 bg-[#E5F6FF] text-[#02537F] font-semibold rounded-md px-2 h-[35px] text-2xl hover:bg-[#d6edf9] transition"
>
  <TbEdit />
</button>

<button
  onClick={() => onDelete()}
  className="flex items-center gap-1 text-2xl font-semibold bg-[#FFE4E7] text-[#D23C3C]  rounded-md px-2 h-[35px]  hover:bg-[#ffd6d6] transition"
>
  <RiDeleteBin6Line  />
</button>
</div>

  </div>
</div>

  );
}

